<template>
  <div>
    <h3>Présentation et Disponibilité</h3>
    <VeeForm :validation-schema="schema" @submit="onSubmit">
      <fieldset>
        <div class="mb-3">
          <label for="presentation" class="form-label">Présentez-vous brièvement (expérience, compétences, etc.) (200 mots maximum) :</label>
          <Field name="presentation" as="textarea" class="form-control" v-model="localFormData.presentation" rows="5" />
          <ErrorMessage name="presentation" class="text-danger" />
        </div>

        <div class="mb-3">
          <label for="disponibilite" class="form-label">Quelle est votre disponibilité ?</label>
          <Field name="disponibilite" as="select" class="form-select" v-model="localFormData.disponibilite">
            <option value="">Sélectionnez votre disponibilité</option>
            <option value="immediate">Immédiate</option>
            <option value="1_mois">Sous 1 mois</option>
            <option value="2_mois">Sous 2 mois</option>
            <option value="3_mois">Sous 3 mois</option>
            <option value="plus_3_mois">Plus de 3 mois</option>
          </Field>
          <ErrorMessage name="disponibilite" class="text-danger" />
        </div>
      </fieldset>

      <button type="button" class="btn btn-secondary me-2" @click="$emit('prev')">Précédent</button>
      <button type="submit" class="btn btn-primary">Suivant</button>
    </VeeForm>
  </div>
</template>

<script>
import { Form as VeeForm, Field, ErrorMessage } from 'vee-validate'
import { defineRule } from 'vee-validate'
import { required } from '@vee-validate/rules'

defineRule('required', required)
defineRule('max_words', (value, [limit]) => {
  if (!value) return true
  const wordCount = value.trim().split(/\s+/).length
  if (wordCount > limit) {
    return `Ce champ ne doit pas dépasser ${limit} mots.`
  }
  return true
})

export default {
  name: 'MotivationActivite',
  components: {
    VeeForm,
    Field,
    ErrorMessage
  },
  props: ['formData'],
  emits: ['update:formData', 'next', 'prev'],
  data() {
    return {
      localFormData: { ...this.formData },
      schema: {
        presentation: 'required|max_words:200',
        disponibilite: 'required'
      }
    }
  },
  methods: {
    onSubmit() {
      this.$emit('update:formData', this.localFormData)
      this.$emit('next')
    }
  }
}
</script>

<style scoped>
textarea {
  min-height: 150px;
}
</style>